module.exports = __webpack_public_path__ + "img/vickyc5_banner.15b6b0f1.jpg";